// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_IKiQZ","dot":"index_dot_LZSqj","current":"index_current_n-RlE","item":"index_item_Pl-Q8"};